function PassengerReviewPageHandler(product = "", event = "", data = {}) {
  const { metaData = {}, setData = {} } = data,
    {
      userId = "",
      name: userName = "",
      email: userEmail = "",
      mobile: userContact = "",
      balance = 0,
      role = "",
    } = metaData,
    {
      tripInfos = [],
      searchQuery = {},
      bookingId = "",
      totalPriceInfo = {},
    } = setData,
    { totalFareDetail = {} } = totalPriceInfo,
    { fC = {} } = totalFareDetail,
    { TF = "", NF = "", NCM = 0 } = fC,
    {
      routeInfos = [],
      ft = "",
      cc = "",
      sI = {},
      cabinClass = "",
      searchId = "",
      searchType = "",
      isDomestic = "",
    } = searchQuery;
  const journeyType = isDomestic
    ? "Domestic"
    : isDomestic === false
    ? "International"
    : "";
  let suppliers = [];
  let supplierBrand = [];
  let fareTypes = [];
  tripInfos.map((item) => {
    const { processedTripInfo = {}, totalPriceList = [] } = item,
      { sups = [], aI = {} } = processedTripInfo,
      { name = "" } = aI;
    supplierBrand.push(name);
    sups.map((sup) => {
      suppliers.push(sup);
    });
    totalPriceList.map((info) => {
      const { fareIdentifier = "" } = info;
      fareTypes.push(fareIdentifier);
    });
  });
  const supplier = suppliers.join(",");
  const supplierBrandName = supplierBrand.join(",");
  const fareType = fareTypes.join(",");
  const [firstRouteInfo = {}] = routeInfos,
    { fromCityOrAirport = {}, toCityOrAirport = {} } = firstRouteInfo,
    {
      city: destinationCity = "",
      code: destinationCityCode = "",
      countryCode: destinationCountryCode = "",
      country: destinationCountry = "",
    } = toCityOrAirport,
    {
      city: originCity = "",
      code: originCityCode = "",
      countryCode: originCountryCode = "",
      country: originCountry = "",
    } = fromCityOrAirport;
  const commonData = {
    Identity: userId,
    walletBalance: balance,
    role,
    destinationCity,
    destinationCityCode,
    destinationCountryCode,
    destinationCountry,
    originCity,
    originCityCode,
    originCountryCode,
    originCountry,
    supplier,
    class: cabinClass,
    requestId: searchId,
    bookingId,
    grossFare: TF,
    netFare: NF,
    commission: NCM,
    tripType: searchType,
    journeyType,
    supplierBrand: supplierBrandName,
    fareType,
  };
  let finalData = {};
  switch (event) {
    case "PageView":
      finalData = { ...commonData };
      break;
    case "Block":
      finalData = { ...commonData };
      break;
    case "ProceedToPay":
      finalData = { ...commonData };
      break;
  }
  return finalData;
}

module.exports = { PassengerReviewPageHandler };
